import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'Tiradas Poderosas™',
  desc: 'Aprende exactamente qué tirada utilizar según la consulta y cómo interpretar el mensaje paso a paso.',
  price: '$19.990 ARS',
  image: 'https://cdn.magicpatterns.com/uploads/gGaaQGCxcJHV9HKT9ewwM9/BONO_1.png'
}, {
  num: 2,
  title: 'Diccionario Intuitivo™',
  desc: 'Consulta los significados esenciales de los 78 Arcanos cuando tengas dudas y aprende mucho más rápido.',
  price: '$19.990 ARS',
  image: 'https://cdn.magicpatterns.com/uploads/tPEHcbXx4yDU2uNBEKWFfR/BONO_2.png'
}, {
  num: 3,
  title: 'Rituales con Tarot™',
  desc: 'Descubre pequeños rituales para preparar tus lecturas, limpiar tu mazo y crear un espacio lleno de calma.',
  price: '$19.990 ARS',
  image: 'https://cdn.magicpatterns.com/uploads/4ZJ5DRdG2gGWYD4ic5SG4Y/BONO_3.png'
}, {
  num: 4,
  title: 'Preguntas Mágicas™',
  desc: 'Aprende a formular preguntas inteligentes para obtener respuestas mucho más útiles, profundas y reveladoras.',
  price: '$19.990 ARS',
  image: 'https://cdn.magicpatterns.com/uploads/dFg831kTogFdmjXbgYLFZo/BONO_4.png'
}, {
  num: 5,
  title: 'Lecturas Reales™',
  desc: 'Aprende observando lecturas reales explicadas de principio a fin y desarrolla seguridad para interpretar.',
  price: '$19.990 ARS',
  image: 'https://cdn.magicpatterns.com/uploads/o1BfRrB6D5Zpjh6uU7oU2Q/BONO_5.1.png'
}];
export function BonusSection() {
  return <section className="px-5 relative overflow-hidden" data-id="element-34">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-35">
        <div className="text-center mb-10" data-id="element-36">
          <div className="flex justify-center mb-4" data-id="element-37">
            <div className="bg-brand-gold-warm/10 p-4 rounded-full" data-id="element-38">
              <Gift className="text-brand-gold-warm" size={40} data-id="element-39" />
            </div>
          </div>
          <h2 className="md:text-5xl font-bold text-brand-petroleum mb-6 tracking-tight text-[24px]" data-id="element-40">
            Además recibís estos{' '}
            <span className="text-brand-terracotta" data-id="element-41">5 bonos exclusivos</span>{' '}
            sin costo
          </h2>
          <p className="text-brand-medium-grey text-sm font-semibold uppercase tracking-widest leading-relaxed" data-id="element-42">
            Diseñados para acelerar tu aprendizaje y práctica
          </p>
        </div>

        <div className="space-y-6 mb-10" data-id="element-43">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white rounded-3xl pt-8 md:pt-12 px-8 md:px-12 pb-6 md:pb-8 shadow-premium border border-brand-petroleum/5 group flex flex-col items-center text-center" data-id="element-44">
              <div className="bg-brand-soft-cream px-4 py-1 rounded-full text-[10px] font-bold text-brand-terracotta uppercase tracking-[0.2em] mb-8 border border-brand-terracotta/10" data-id="element-45">
                Bono {bonus.num} — Gratis
              </div>

              <div className="mb-8 max-w-[280px] w-full" data-id="element-46">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500" width="280" height="350" loading="lazy" data-id="element-47" />
              </div>

              <h3 className="text-2xl font-bold text-brand-petroleum mb-4 tracking-tight" data-id="element-48">
                {bonus.title}
              </h3>
              <p className="text-brand-medium-grey text-base leading-relaxed mb-6 max-w-md" data-id="element-49">
                {bonus.desc}
              </p>

              <div className="bg-brand-warm-white rounded-2xl p-4 border border-brand-petroleum/5 w-full max-w-xs" data-id="element-50">
                <p className="text-[10px] text-brand-medium-grey uppercase tracking-widest mb-1" data-id="element-51">
                  Valor real
                </p>
                <p className="text-lg font-bold text-brand-dark-grey line-through opacity-40" data-id="element-52">
                  {bonus.price}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-petroleum rounded-[40px] p-10 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-53">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold-warm/10 blur-3xl rounded-full -mr-32 -mt-32" data-id="element-54"></div>
          <p className="text-white/60 text-xs font-bold uppercase tracking-widest mb-4" data-id="element-55">
            Valor total bonos: +$95.990 ARS
          </p>
          <div className="flex flex-col items-center gap-4 mb-4" data-id="element-56">
            <h3 className="text-3xl md:text-4xl font-bold text-white leading-tight tracking-tight" data-id="element-57">
              Todo incluido:{' '}
              <span className="text-brand-gold-warm" data-id="element-58">Gratis</span>
            </h3>
          </div>
          <p className="text-white/40 text-[10px] font-medium uppercase tracking-[0.2em] mt-8" data-id="element-59">
            (Solo mientras esta oferta de lanzamiento esté activa)
          </p>
        </div>
      </div>
    </section>;
}